import { KybFieldName } from '@marketplace-web/domain/business-accounts'

export const isFieldRequired = (requiredFields: Array<string>, fieldName: KybFieldName) =>
  requiredFields?.includes(fieldName)
